import type { Ref } from 'vue'

/**
 * `ComboboxInput`'s focus-opens-panel wiring is dead in the installed `@headlessui/vue`
 * (`immediate` never reaches the context), so a click only focuses the search input — typing is
 * what actually opens the panel today. Returns a click handler that simulates a click on the
 * chevron instead, which toggles correctly; it skips when another control (a chip's remove "x",
 * a clear button) was the real click target, or the panel is already open. `pointer-events: none`
 * on a chevron only blocks real pointer input — `.click()` still fires its handler.
 */
export function useComboboxClickOpen(
  reference: Ref<HTMLElement | null>,
  chevronSelector: string,
  enabled: () => boolean,
) {
  return function onControlClick(event: MouseEvent): void {
    if (!enabled()) return
    const target = event.target
    if (!(target instanceof HTMLElement) || target.closest('button')) return
    const chevron = reference.value?.querySelector<HTMLButtonElement>(chevronSelector)
    if (!chevron || chevron.getAttribute('aria-expanded') === 'true') return
    chevron.click()
  }
}
